/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import React from 'react';
import { useLanguage } from '@/providers/LanguageProvider';

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { CustomButton } from '@/components/common';

const ArchitectureServiceDialog = ({
  endpointUrl,
  openDialog,
  setOpenDialog,
}: {
  endpointUrl: string;
  openDialog: boolean;
  setOpenDialog: (value: boolean) => void;
}) => {
  const { messages } = useLanguage();
  const generalIntl = messages?.Architecture;

  const handleContinue = () => {
    window.open(endpointUrl, '_blank', 'noopener,noreferrer');
    setOpenDialog(false);
  };
  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <Dialog open={openDialog} onOpenChange={handleClose}>
      <DialogContent
        className="max-w-[640px] bg-gradient-sky-dark"
        aria-describedby={undefined}
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="text-2xl font-normal leading-7 text-body-primary">
            {generalIntl?.external_link}
          </DialogTitle>
        </DialogHeader>

        <Separator className="mt-1 bg-line-primary" />
        <p className="text-sm">{generalIntl?.external_link_warning}</p>
        <DialogFooter className="pt-2 sm:justify-start">
          <CustomButton
            type="button"
            customSize="regular"
            customVariant="primary"
            onClick={handleContinue}
          >
            {generalIntl?.continue}
          </CustomButton>
          <DialogClose asChild>
            <CustomButton customSize="regular" customVariant="secondary">
              {generalIntl?.stay}
            </CustomButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ArchitectureServiceDialog;
